// extracted by mini-css-extract-plugin
module.exports = {"volume":"_1-Yq0T","checkmark":"_2QpFWx","white":"_2pbT7Q","black":"_1HfcbT","active":"_38GB1C","missingColor":"_3BmpoO","volumeContainer":"_3FMtjW"};